import React from 'react';

const baseButton = {
  padding: '15px 32px',
  fontSize: '12px',
  letterSpacing: '2px',
  fontWeight: 600,
};

export const HeroButtons = ({ t, onExploreMenu, onOrderNow, onSeeNews, localizedOrderDay }) => (
  <div className="flex flex-wrap gap-4 mt-9">
    <button
      onClick={onExploreMenu}
      className="font-body uppercase text-white transition-colors duration-200"
      style={{ ...baseButton, background: '#C8282B' }}
      onMouseEnter={(e) => (e.currentTarget.style.background = '#9B1F22')}
      onMouseLeave={(e) => (e.currentTarget.style.background = '#C8282B')}
      data-testid="hero-explore-menu"
    >
      {t('hero.explorarMenu')}
    </button>
    <button
      onClick={onOrderNow}
      className="font-body uppercase transition-colors duration-200"
      style={{ ...baseButton, background: '#C9A84C', color: '#0A0A0A' }}
      onMouseEnter={(e) => (e.currentTarget.style.background = '#B8963E')}
      onMouseLeave={(e) => (e.currentTarget.style.background = '#C9A84C')}
      data-testid="hero-order-now"
    >
      {t('hero.ordenar')}{localizedOrderDay ? ` (${localizedOrderDay})` : ''}
    </button>
    <button
      onClick={onSeeNews}
      className="font-body uppercase transition-colors duration-200"
      style={{ ...baseButton, border: '1px solid #C9A84C', color: '#C9A84C' }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#C9A84C';
        e.currentTarget.style.color = '#0A0A0A';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.color = '#C9A84C';
      }}
      data-testid="hero-see-news"
    >
      {t('hero.verNovedades')}
    </button>
  </div>
);
